/*! rkc-chat-toggle.js
 * Toggle social links menu (non-blocking)
 */
(function(){
  function init(){
    var t=document.getElementById("chatButton");
    var e=document.getElementById("socialLinks");
    if(!t||!e) return;
    var open=false;
    function set(v){ open=v; e.style.display=open?"block":"none"; }
    t.addEventListener("click",function(ev){ ev.stopPropagation(); set(!open); }, {passive:true});
    document.addEventListener("click",function(ev){
      if(t.contains(ev.target) || e.contains(ev.target)) return;
      set(false);
    }, {passive:true});
  }
  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded", init, {once:true});
  }else{
    init();
  }
})();